


















































import Vue from "vue";
import _ from "@/boot/lodash";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  methods: {
    update: _.debounce(function(this: MarkDownEditor, input) {
      this.input = input;
      this.$emit("input", this.input);
    }, 300)
  }
})
export default class MarkDownEditor extends Vue {
  @Prop({ required: false, default: "" })
  public value!: string;

  public input = "";
  public showPreview = true;

  @Watch("value")
  public onValueChange(newVal) {
    this.input = newVal;
  }

  public created() {
    this.input = this.value;
  }

  public get previewTooltipMessage() {
    return this.showPreview
      ? this.$t("_action.hide_object", { object: this.$t("_.preview") })
      : this.$t("_action.show_object", { object: this.$t("_.preview") });
  }

  public openWiki() {
    window.open(`https://en.wikipedia.org/wiki/Markdown#Example`, "_blank");
  }

  public onShowPreview() {
    this.showPreview = !this.showPreview;
  }
}
